import PageContainer from '@/common/components/PageContainer'
import CreateRankListing from '@/modules/manage-rank/components/CreateRank/components/CreateRankListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function CreateRankPage() {
	return (
		<PageContainer>
			<CreateRankListing />
		</PageContainer>
	)
}

const GuardedCreateRankPage = withUserPermission(CreateRankPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_RANK],
})

export default GuardedCreateRankPage
